<script lang="ts">
  import { defineComponent } from "vue";
  import FicheManualBillingDocument from '@/generated/fiches/FicheManualBillingDocument.vue';
  export default defineComponent({
    extends: FicheManualBillingDocument,
    components: {}
})
</script>
